import ReCAPTCHA from 'react-google-recaptcha-enterprise';
import { useRecaptcha } from './hooks';

interface RecaptchaProps {
  onChange: (token: string | null) => void;
  recaptchaKey: string;
}

export const Recaptcha = ({ onChange, recaptchaKey }: RecaptchaProps) => {
  const { recaptchaRef } = useRecaptcha();

  const handleCaptcha = (token: string | null) => {
    if (!!token) {
      onChange(token);
    } else {
      onChange(null);
    }
  };

  return <ReCAPTCHA ref={recaptchaRef} sitekey={recaptchaKey} onChange={handleCaptcha} />;
};
